import {css, cx} from "@panda/css";

import {LocationIcon} from "@pg-design/icons-module";
import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/**
 * "Ceny w mojej okolicy" row. There is no dedicated location glyph, so this reuses the design-system `LocationIcon` (a filled
 * 10×10 navigation arrow, drawn at `size`) - to be replaced once design delivers a stroke icon matching the others.
 */
export const PricesSearchLocationIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <span className={cx(iconWrapperStyle, className)} data-testid={dataTestId} aria-hidden="true">
            <LocationIcon width={size} height={size} fill="currentColor" />
        </span>
    );
};

const iconWrapperStyle = css({
    display: "inline-flex"
});
import {css, cx} from "@panda/css";

import {LocationIcon} from "@pg-design/icons-module";
import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/**
 * "Ceny w mojej okolicy" row. There is no dedicated location glyph, so this reuses the design-system `LocationIcon` (a filled
 * 10×10 navigation arrow, drawn at `size`) - to be replaced once design delivers a stroke icon matching the others.
 */
export const PricesSearchLocationIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <span className={cx(iconWrapperStyle, className)} data-testid={dataTestId} aria-hidden="true">
            <LocationIcon width={size} height={size} fill="currentColor" />
        </span>
    );
};

const iconWrapperStyle = css({
    display: "inline-flex"
});
